class Video {
  #videoElement = null;
  #videoLink = null;
  #videoMedia = null;
  #videoButton = null;
  #videoLocal = null;
  constructor(video) {
    this.#videoElement = video;
    this.#videoLink = video.querySelector("[data-video-link]");
    this.#videoMedia = video.querySelector("[data-video-media]");
    this.#videoButton = video.querySelector("[data-video-button]");
    this.#videoLocal = video.querySelector("[data-video-local]");
    this.init();
  }

  init() {
    this.#videoLink.addEventListener("click", (e) => e.preventDefault());

    this.#videoElement.addEventListener("click", () => {
      const id = this.#parseMediaUrl(this.#videoLink);
      const iframe = this.#createIframe(id);
      console.log(this.#videoLink);
      this.#videoLink.remove();
      if (this.#videoButton) this.#videoButton.remove();

      if (!this.#videoLocal && !document.querySelector(`[data-src="${id}"]`)) {
        this.#videoElement.appendChild(iframe);
      }

      const player = this.#videoElement.querySelector("[data-iframe]");

      this.#videoLocal.play();
      function doCommand(CommandJSON) {
        player.contentWindow.postMessage(
          JSON.stringify(CommandJSON),
          "https://rutube.ru"
        );
        player.contentWindow.postMessage(
          JSON.stringify(CommandJSON),
          "https://ssp.rutube.ru"
        );
        player.contentWindow.postMessage(
          JSON.stringify(CommandJSON),
          window.location.origin
        );
      }

      function do_play() {
        doCommand({
          type: "player:play",
          data: {},
        });
      }

      setTimeout(() => {
        do_play();
      }, 1000);
    });

    this.#videoElement.classList.add("video--enabled");
  }

  #parseMediaUrl = (media) => media.href;

  #createIframe = (id) => {
    const iframe = document.createElement("iframe");

    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("allow", "autoplay");
    iframe.setAttribute("src", this.#generateUrl(id));
    iframe.dataset.iframe = "test";
    iframe.dataset.src = id;
    iframe.classList.add("video__media");

    return iframe;
  };

  #generateUrl = (id) => {
    const query = "?rel=0&showinfo=0&autoplay=1";

    return id + query;
  };
}

const initVidios = () => {
  const videos = document.querySelectorAll("[data-video]");
  if (videos.length) {
    videos.forEach((video) => {
      const videoElement = new Video(video);
    });
  }
};

export { initVidios };
